var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 2a7 7 0 1 0 0 14A7 7 0 0 0 9 2m.048 2a1 1 0 0 1 1 1v3.048h3.048a1 1 0 0 1-.001 2h-3.047v3.048a1 1 0 0 1-2 0v-3.048H4.999a1.001 1.001 0 0 1 .001-2h3.048V5a1 1 0 0 1 1-1"
})));
export default SvgPlus;